import React, { useState } from "react";
import experiences from "./experiences.js";
import ExpButton from "./expButton.js";
import { motion } from "framer-motion";

const ExperienceSection = () => {
  const [activeExperience, setActiveExperience] = useState(0);

  return (
    <div
      id="experience-section"
      className="relative bg-[var(--pmBackground)] w-full min-h-screen flex items-center overflow-x-hidden justify-center lg:justify-end px-4 lg:pr-40 text-base overflow-y-hidden"
    >
      <div className="absolute text-white select-none font-bold text-[19vw] sm:text-[15vw] md:text-[15vw] lg:text-[18vw] left-4 bottom-0 leading-[15vw] opacity-5">
        MY WORK <br />
        EXPERIENCE
      </div>
      <motion.div className="flex flex-col lg:flex-row z-10 w-full h-fit lg:w-auto items-start gap-8 lg:gap-16 font-gambetta ">
        <motion.div
          whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
          initial={{ clipPath: "inset(0% 0% 0% 100%)", opacity: 0.3 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: false }}
          className="relative text-white rounded-md px-6 py-6 lg:px-10 lg:py-8 w-full h-full lg:w-[45rem] bg-[var(--darkGrey)] flex flex-col justify-between"
        >
          <div>
            <div className="text-md md:text-xl lg:text-2xl">
              {experiences[activeExperience].company}
            </div>
            <div className="text-md md:text-xl font-light">
              {experiences[activeExperience].positionName}
            </div>
            <div className="flex mt-4 text-sm md:text-base">
              <div>{experiences[activeExperience].start}</div>
              <div className="w-8"></div>
              <div>{experiences[activeExperience].end}</div>
            </div>
          </div>
          <div className="absolute top-4 right-4 lg:top-7 lg:right-8">
            <img
              src={experiences[activeExperience].logo}
              className="h-[40px] md:h-[50px] lg:h-[60px] object-contain"
            />
          </div>
          <div className="">
            <div className="mt-8 lg:mt-12 space-y-2">
              {experiences[activeExperience].desc.map((descItem, index) => {
                return (
                  <div key={index} className="mb-2 text-sm md:text-base">
                    {descItem}
                  </div>
                );
              })}
            </div>
            <div className="mt-9">
              {experiences[activeExperience].technologies}
            </div>
          </div>
        </motion.div>
        <div className="flex flex-col gap-4 z-10 w-full lg:w-[350px] items-center lg:items-stretch">
          {experiences.map((experience, index) => {
            return (
              <ExpButton
                key={index}
                index={index}
                activeExperience={activeExperience}
                setActiveExperience={setActiveExperience}
                experience={experience}
              />
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

export default ExperienceSection;
